import { ArrayInput, NumberInput, SimpleFormIterator, TextInput } from '@/components/admin';
import { calculateTax } from '../documents/shared/TaxCalculator';
import { useSimpleFormIterator, useSimpleFormIteratorItem } from 'ra-core';
import { useFormContext, useWatch } from 'react-hook-form';
import { useEffect } from 'react';

const LineCalculations = ({ source }: { source: string }) => {
    const { setValue } = useFormContext();
    const quantity = useWatch({ name: `${source}.quantity` }) || 0;
    const unitPrice = useWatch({ name: `${source}.unit_price` }) || 0;
    const taxRate = useWatch({ name: `${source}.tax_rate` }) || 0;

    const amount = quantity * unitPrice;
    const tax = calculateTax({ amount, taxRate });
    const lineTotal = amount + tax.totalTax;

    useEffect(() => {
        setValue(`${source}.tax_amount`, tax.totalTax, { shouldDirty: true });
        setValue(`${source}.line_total`, lineTotal, { shouldDirty: true });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tax.totalTax, lineTotal, source, setValue]);

    return (
        <div className="flex flex-col items-end justify-center w-full h-[2.75rem] px-3 bg-primary/10 rounded-lg border border-primary/20 shadow-xs">
            <span className="font-bold text-sm text-primary/90">₹{lineTotal.toFixed(2)}</span>
            <span className="text-[10px] text-primary/90 font-bold leading-none mt-0.5">Includes ₹{tax.totalTax.toFixed(2)}</span>
        </div>
    );
};

// Reads the current iterator item's source path so LineCalculations can watch it.
const FormLineTotal = () => {
    const item = useSimpleFormIteratorItem();
    const iterator = useSimpleFormIterator();
    return <LineCalculations source={`${iterator.source}.${item.index}`} />;
};

/** Line-item editor for a Vendor Bill (vendor_bill_items). Kept separate from
 * DocumentItemsTable since vendor_bill_items has no hsn_code/unit columns. */
export const VendorBillItemsInput = () => (
    <ArrayInput source="items" label="Line Items">
        <SimpleFormIterator disableReordering>
            <div className="grid grid-cols-[minmax(0,1fr)_90px_150px_90px_190px] gap-3 items-end w-full">
                <TextInput source="item_description" label="Description" helperText={false} className="w-full" />
                <NumberInput source="quantity" label="Qty" helperText={false} defaultValue={1} className="w-full" />
                <NumberInput source="unit_price" label="Price (₹)" helperText={false} defaultValue={0} className="w-full" />
                <NumberInput source="tax_rate" label="GST %" helperText={false} defaultValue={18} className="w-full" />
                <FormLineTotal />
            </div>
        </SimpleFormIterator>
    </ArrayInput>
);
